module.exports = __webpack_public_path__ + "9258e4459d4c02038dbfe1ec8f24bbc5.svg";